import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadDeactivateAccounts = createAction('[DeactivateAccount] Load DeactivateAccounts', props<{ businessId: string }>());

export const loadDeactivateAccountsSuccess = createAction(
  '[DeactivateAccount] Load DeactivateAccounts Success',
  props<{ response: string }>()
);

export const loadDeactivateAccountsFailure = createAction(
  '[DeactivateAccount] Load DeactivateAccounts Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
